// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3Emuw","header":"PatientQuestionnaire_header__14gd0","info":"PatientQuestionnaire_info__6PQVZ"};